export default "__VITE_ASSET__BBDCg4Ri__"